import home from "./modules/home.js"
import webset from "./modules/webset.js"

export default {
  ...home,
  ...webset,
}